import _isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import _get from "lodash/get";
import React, { Component } from "react";
import { Grid, Header, Label } from "semantic-ui-react";
import LiteratureTitle from "@modules/Literature/LiteratureTitle";
import { Media } from "@components/Media";

export class SpecialCollectionTitle extends Component {
  subtitle() {
    const {
      metadata: { alternative_titles },
    } = this.props;
    if (!_isEmpty(alternative_titles)) {
      const subtitle = alternative_titles.find((e) => e.type === "SUBTITLE");
      if (!_isEmpty(subtitle)) {
        return <Header.Subheader>{subtitle.value}</Header.Subheader>;
      }
    }
  }

  getCollectionTypeLabel() {
    const { metadata } = this.props;
    const collectionTypeMap = {
      GRADUATE_THESIS: "GRADUATE THESIS",
      UNDERGRADUATE_THESIS: "UNDERGRADUATE THESIS",
      DISSERTATION: "DISSERTATION",
      ENCYCLOPEDIA: "ENCYCLOPEDIA",
      HANDBOOK: "HANDBOOK",
      OTHER: "-",
    };

    return (
      collectionTypeMap[metadata.collection_type] ||
      metadata.collection_type ||
      "Special Collection"
    );
  }

  getAcademicInfo() {
    const { metadata } = this.props;
    const academicInfo = _get(metadata, "academic_info", {});

    if (_isEmpty(academicInfo)) return null;

    const parts = [];
    if (academicInfo.department) parts.push(academicInfo.department);
    if (academicInfo.program) parts.push(academicInfo.program);

    return parts.length > 0 ? parts.join(" | ") : null;
  }

  render() {
    const { metadata } = this.props;
    const academicInfo = this.getAcademicInfo();
    const publicationYear = metadata.publication_year;

    return (
      <>
        <Media greaterThanOrEqual="tablet">
          <Grid columns={2}>
            <Grid.Row className="pb-0">
              <Grid.Column textAlign="left">
                {this.getCollectionTypeLabel()}
              </Grid.Column>
            </Grid.Row>
            {academicInfo && (
              <Grid.Row className="pb-0 pt-0">
                <Grid.Column textAlign="left" verticalAlign="bottom" />
              </Grid.Row>
            )}
          </Grid>
        </Media>
        <Media lessThan="tablet">
          <Grid columns={2} textAlign="center">
            <Grid.Row className="pb-0 pt-2">
              {this.getCollectionTypeLabel()}
            </Grid.Row>
            {academicInfo && (
              <Grid.Row className="pb-0">
                <Header>
                  <Header.Subheader className="academic-info">
                    {academicInfo}
                  </Header.Subheader>
                </Header>
              </Grid.Row>
            )}
            <Grid.Row className="pb-0">
              {publicationYear && <Label>{publicationYear}</Label>}
            </Grid.Row>
          </Grid>
        </Media>
        <Header as="h2" className="document-title">
          <LiteratureTitle
            title={metadata.title}
            publicationYear={metadata.publication_year}
            truncate={false}
          />
          {this.subtitle()}
        </Header>
      </>
    );
  }
}

SpecialCollectionTitle.propTypes = {
  metadata: PropTypes.object.isRequired,
};
